"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["time"],

  methods: {
    getFormattedDate: function getFormattedDate(time) {
      return Fn.getFormattedDate(time);
    }
  },

  computed: {
    /**
     * Delete button message text
     * @returns {VueI18n.TranslateResult}
     */
    title: function title() {
      if (this.time.type && this.time.type.name) {
        return this.$t("dashboard.headers.booked_time", {
          date: this.getFormattedDate(this.time.time),
          type: this.time.type.name
        });
      }

      return this.$t("dashboard.headers.you_have_booked", {
        date: this.getFormattedDate(this.time.time)
      });
    },
    description: function description() {
      if (this.time.location && this.time.location.name) {
        return this.time.location && this.time.location.name;
      }

      return "";
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/dashboard/DeleteBookingButton.vue
// module id = ftwP
// module chunks = 0 1